import { LoadBliksyChatHistoryResponseSchema } from './load-bliksy-chat-history.schema';
/**
 * Load Bliksy Chat History Feature
 * Retrieves the chat history for a given session
 */ export const loadBliksyChatHistoryContract = {
    method: 'GET',
    path: '/api/v2/bliksy/chat-history/:sessionId',
    description: 'Load chat history for a bliksy session',
    responseSchema: LoadBliksyChatHistoryResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            404: 'Session not found'
        }
    }
};

//# sourceMappingURL=load-bliksy-chat-history.contract.js.map